// Typelizer digest 1e79fa205316cb84e6a77bbce7cc71b3
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/relief/invitations/:invitation_id/response/new */
  new: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/relief/invitations/:invitation_id/response/new', params, options),
    method: 'get',
  }),

  /** GET /educators/relief/invitations/:invitation_id/response */
  show: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/relief/invitations/:invitation_id/response', params, options),
    method: 'get',
  }),

  /** POST /educators/relief/invitations/:invitation_id/response */
  create: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/relief/invitations/:invitation_id/response', params, options),
    method: 'post',
  }),
}
